jQuery( document ).ready(function() {
    if( jQuery('section.pipeline').length ) {
        
        // Toggle drug details
        jQuery('.product').on('click', '.product-info-toggle', function () {
            jQuery(this).parents('.product').toggleClass('collapsed');
        });

        jQuery( window ).scroll();
        
    }
});
var scrollTimer;
jQuery( window ).scroll(function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
        // Animate progress bar
        if( jQuery('section.pipeline .products .product:not(.elem-in-viewport)').length ) {
            jQuery( "section.pipeline .products .product:not(.elem-in-viewport)" ).each(function() {
                if( jQuery( this ).is( ':in-viewport(0)' ) ) {
                    jQuery( this ).addClass('elem-in-viewport');
                }
            });
        }
	}, 150);
});